// Country flag emoji mapping
export interface FlagEmojiMap {
  [countryCode: string]: string
}

export const FLAG_EMOJI: FlagEmojiMap = {
  AF: '🇦🇫',
  AL: '🇦🇱',
  DZ: '🇩🇿',
  AS: '🇦🇸',
  AD: '🇦🇩',
  AO: '🇦🇴',
  AI: '🇦🇮',
  AG: '🇦🇬',
  AR: '🇦🇷',
  AM: '🇦🇲',
  AW: '🇦🇼',
  AU: '🇦🇺',
  AT: '🇦🇹',
  AZ: '🇦🇿',
  BS: '🇧🇸',
  BH: '🇧🇭',
  BD: '🇧🇩',
  BB: '🇧🇧',
  BY: '🇧🇾',
  BE: '🇧🇪',
  BZ: '🇧🇿',
  BJ: '🇧🇯',
  BM: '🇧🇲',
  BT: '🇧🇹',
  BO: '🇧🇴',
  BA: '🇧🇦',
  BW: '🇧🇼',
  BR: '🇧🇷',
  IO: '🇮🇴',
  VG: '🇻🇬',
  BN: '🇧🇳',
  BG: '🇧🇬',
  BF: '🇧🇫',
  BI: '🇧🇮',
  KH: '🇰🇭',
  CM: '🇨🇲',
  CA: '🇨🇦',
  CV: '🇨🇻',
  BQ: '🇧🇶',
  KY: '🇰🇾',
  CF: '🇨🇫',
  TD: '🇹🇩',
  CL: '🇨🇱',
  CN: '🇨🇳',
  CO: '🇨🇴',
  KM: '🇰🇲',
  CD: '🇨🇩',
  CG: '🇨🇬',
  CK: '🇨🇰',
  CR: '🇨🇷',
  CI: '🇨🇮',
  HR: '🇭🇷',
  CU: '🇨🇺',
  CW: '🇨🇼',
  CY: '🇨🇾',
  CZ: '🇨🇿',
  DK: '🇩🇰',
  DJ: '🇩🇯',
  DM: '🇩🇲',
  DO: '🇩🇴',
  EC: '🇪🇨',
  EG: '🇪🇬',
  SV: '🇸🇻',
  GQ: '🇬🇶',
  ER: '🇪🇷',
  EE: '🇪🇪',
  ET: '🇪🇹',
  FK: '🇫🇰',
  FO: '🇫🇴',
  FJ: '🇫🇯',
  FI: '🇫🇮',
  FR: '🇫🇷',
  GF: '🇬🇫',
  PF: '🇵🇫',
  GA: '🇬🇦',
  GM: '🇬🇲',
  GE: '🇬🇪',
  DE: '🇩🇪',
  GH: '🇬🇭',
  GI: '🇬🇮',
  GR: '🇬🇷',
  GL: '🇬🇱',
  GD: '🇬🇩',
  GP: '🇬🇵',
  GU: '🇬🇺',
  GT: '🇬🇹',
  GN: '🇬🇳',
  GW: '🇬🇼',
  GY: '🇬🇾',
  HT: '🇭🇹',
  HN: '🇭🇳',
  HK: '🇭🇰',
  HU: '🇭🇺',
  IS: '🇮🇸',
  IN: '🇮🇳',
  ID: '🇮🇩',
  IR: '🇮🇷',
  IQ: '🇮🇶',
  IE: '🇮🇪',
  IL: '🇮🇱',
  IT: '🇮🇹',
  JM: '🇯🇲',
  JP: '🇯🇵',
  JO: '🇯🇴',
  KZ: '🇰🇿',
  KE: '🇰🇪',
  KI: '🇰🇮',
  XK: '🇽🇰',
  KW: '🇰🇼',
  KG: '🇰🇬',
  LA: '🇱🇦',
  LV: '🇱🇻',
  LB: '🇱🇧',
  LS: '🇱🇸',
  LR: '🇱🇷',
  LY: '🇱🇾',
  LI: '🇱🇮',
  LT: '🇱🇹',
  LU: '🇱🇺',
  MO: '🇲🇴',
  MK: '🇲🇰',
  MG: '🇲🇬',
  MW: '🇲🇼',
  MY: '🇲🇾',
  MV: '🇲🇻',
  ML: '🇲🇱',
  MT: '🇲🇹',
  MH: '🇲🇭',
  MQ: '🇲🇶',
  MR: '🇲🇷',
  MU: '🇲🇺',
  MX: '🇲🇽',
  FM: '🇫🇲',
  MD: '🇲🇩',
  MC: '🇲🇨',
  MN: '🇲🇳',
  ME: '🇲🇪',
  MS: '🇲🇸',
  MA: '🇲🇦',
  MZ: '🇲🇿',
  MM: '🇲🇲',
  NA: '🇳🇦',
  NR: '🇳🇷',
  NP: '🇳🇵',
  NL: '🇳🇱',
  NC: '🇳🇨',
  NZ: '🇳🇿',
  NI: '🇳🇮',
  NE: '🇳🇪',
  NG: '🇳🇬',
  NU: '🇳🇺',
  NF: '🇳🇫',
  KP: '🇰🇵',
  MP: '🇲🇵',
  NO: '🇳🇴',
  OM: '🇴🇲',
  PK: '🇵🇰',
  PW: '🇵🇼',
  PS: '🇵🇸',
  PA: '🇵🇦',
  PG: '🇵🇬',
  PY: '🇵🇾',
  PE: '🇵🇪',
  PH: '🇵🇭',
  PL: '🇵🇱',
  PT: '🇵🇹',
  PR: '🇵🇷',
  QA: '🇶🇦',
  RE: '🇷🇪',
  RO: '🇷🇴',
  RU: '🇷🇺',
  RW: '🇷🇼',
  BL: '🇧🇱',
  SH: '🇸🇭',
  KN: '🇰🇳',
  LC: '🇱🇨',
  MF: '🇲🇫',
  PM: '🇵🇲',
  VC: '🇻🇨',
  WS: '🇼🇸',
  SM: '🇸🇲',
  ST: '🇸🇹',
  SA: '🇸🇦',
  SN: '🇸🇳',
  RS: '🇷🇸',
  SC: '🇸🇨',
  SL: '🇸🇱',
  SG: '🇸🇬',
  SX: '🇸🇽',
  SK: '🇸🇰',
  SI: '🇸🇮',
  SB: '🇸🇧',
  SO: '🇸🇴',
  ZA: '🇿🇦',
  KR: '🇰🇷',
  SS: '🇸🇸',
  ES: '🇪🇸',
  LK: '🇱🇰',
  SD: '🇸🇩',
  SR: '🇸🇷',
  SZ: '🇸🇿',
  SE: '🇸🇪',
  CH: '🇨🇭',
  SY: '🇸🇾',
  TW: '🇹🇼',
  TJ: '🇹🇯',
  TZ: '🇹🇿',
  TH: '🇹🇭',
  TL: '🇹🇱',
  TG: '🇹🇬',
  TK: '🇹🇰',
  TO: '🇹🇴',
  TT: '🇹🇹',
  TN: '🇹🇳',
  TR: '🇹🇷',
  TM: '🇹🇲',
  TC: '🇹🇨',
  TV: '🇹🇻',
  VI: '🇻🇮',
  UG: '🇺🇬',
  UA: '🇺🇦',
  AE: '🇦🇪',
  GB: '🇬🇧',
  US: '🇺🇸',
  UY: '🇺🇾',
  UZ: '🇺🇿',
  VU: '🇻🇺',
  VA: '🇻🇦',
  VE: '🇻🇪',
  VN: '🇻🇳',
  WF: '🇼🇫',
  YE: '🇾🇪',
  ZM: '🇿🇲',
  ZW: '🇿🇼',
}

/**
 * Get flag display for a country code, with Windows compatibility
 * @param countryCode - The country code (e.g., 'US', 'CA')
 * @param isWindows - Whether the user is on Windows (defaults to platform detection)
 * @returns Flag emoji or country code letters for Windows
 */
export const getFlagDisplay = (countryCode: string, isWindows?: boolean): string => {
  const isWindowsPlatform =
    isWindows ?? (typeof navigator !== 'undefined' && navigator.platform?.toLowerCase().includes('win'))

  if (isWindowsPlatform) {
    // Use country code letters for Windows
    return countryCode
      .split('')
      .map((char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
      .join('')
  }
  return FLAG_EMOJI[countryCode] || '🏳️'
}
